import _ from "lodash";
import moment from "moment";
export default {
  props: {
    tank: Object,
  },
  mounted() {
    this.debounceNome = _.debounce(this.set_nome, 2000);
    this.debounceAltezza = _.debounce(this.set_altezza, 2000);
    this.debounceLarghezza = _.debounce(this.set_larghezza, 2000);
    this.debounceProfond = _.debounce(this.set_profond, 2000);
    this.debounceDiametro = _.debounce(this.set_diametro, 2000);
    this.debounceDensitaLiquido = _.debounce(this.set_densita_liquido, 2000);
    this.debounceOffsetAdc = _.debounce(this.set_offset_adc, 2000);
    this.debounceScalaAdc = _.debounce(this.set_scala_adc, 2000);
    this.debounceIntervalloLettura = _.debounce(this.set_intervallo_lettura, 2000);
    this.debounceIntervalloPingServer = _.debounce(this.set_intervallo_ping_server, 2000);
  },
  data() {
    return {
      hover: false,
      dialog: false,
      show_details: false,
      nome: this.tank.nome,
      tipo: this.tank.type,
      altezza: this.tank.altezza,
      diametro: this.tank.diametro,
      larghezza: this.tank.larghezza,
      profond: this.tank.profond,
      densita_liquido: this.tank.densita_liquido,
      offset_adc: this.tank.adc_offset,
      scala_adc: this.tank.adc_scale,
      intervallo_lettura: this.tank.intervallo_lettura,
      intervallo_ping_server: this.tank.intervallo_aggiornamento,
      tanks_type: [
        { value: 1, text: "Cubica" },
        { value: 2, text: "Cilindrica" },
        { value: 3, text: "Cilindrica Coricata" },
      ],
      dialog_elimina: false,
      snackbar_richiesta: false,
    };
  },
  watch: {
    nome: function () {
      this.debounceNome();
    },
    tipo: function () {
      this.set_tipo();
    },
    altezza: function () {
      this.debounceAltezza();
    },
    larghezza: function () {
      this.debounceLarghezza();
    },
    profond: function () {
      this.debounceProfond();
    },
    diametro: function () {
      this.debounceDiametro();
    },
    densita_liquido: function () {
      this.debounceDensitaLiquido();
    },
    offset_adc: function () {
      this.debounceOffsetAdc();
    },
    scala_adc: function () {
      this.debounceScalaAdc();
    },
    intervallo_lettura: function () {
      this.debounceIntervalloLettura();
    },
    intervallo_ping_server: function () {
      this.debounceIntervalloPingServer();
    },
  },
  computed: {
    nome_tipo() {
      return this.tanks_type.find((tank) => tank.value == this.tank.type).text;
    },
    capacit() {
      if (this.tank.type == 0) {
        return 0;
      } else if (this.tank.type == 1) {
        return this.tank.altezza * this.tank.larghezza * this.tank.profond;
      } else {
        return (
          (Math.pow(this.tank.diametro / 2, 2) * 3.14 * this.tank.altezza) /
          1000
        );
      }
    },
    percentuale_riemp() {
      if (this.capacit == 0) {
        return 0;
      }
      return (this.tank.volume_liquido / this.capacit) * 100;
    },
    isConnected() {
      return (
        this.tank.last_update > moment().subtract(5, "minutes").format("X")
      );
    },
    last_update() {
      return moment.unix(this.tank.last_update).fromNow();
    },
    formatted_last_reading() {
      return this.tank.last_read_time
        ? moment.unix(this.tank.last_read_time).format("DD/MM/YYYY HH:mm")
        : "N/A";
    },
  },
  methods: {
    set_nome() {
      this.$store.dispatch("cambia_nome_tank", {
        id_tank: this.tank.id,
        nome: this.nome,
      });
    },
    set_tipo() {
      this.$store.dispatch("cambia_tipo_tank", {
        id_tank: this.tank.id,
        tipo: this.tipo,
      });
    },
    set_altezza() {
      this.$store.dispatch("cambia_altezza_tank", {
        id_tank: this.tank.id,
        altezza: this.altezza,
      });
    },
    set_larghezza() {
      this.$store.dispatch("cambia_larghezza_tank", {
        id_tank: this.tank.id,
        larghezza: this.larghezza,
      });
    },
    set_profond() {
      this.$store.dispatch("cambia_profond_tank", {
        id_tank: this.tank.id,
        profond: this.profond,
      });
    },
    set_diametro() {
      this.$store.dispatch("cambia_diametro_tank", {
        id_tank: this.tank.id,
        diametro: this.diametro,
      });
    },
    set_densita_liquido() {
      this.$store.dispatch("cambia_densita_liquido_tank", {
        id_tank: this.tank.id,
        densita_liquido: this.densita_liquido,
      });
    },
    set_offset_adc() {
      this.$store.dispatch("cambia_offset_adc_tank", {
        id_tank: this.tank.id,
        offset_adc: this.offset_adc,
      });
    },
    set_scala_adc() {
      this.$store.dispatch("cambia_scala_adc_tank", {
        id_tank: this.tank.id,
        scala_adc: this.scala_adc,
      });
    },
    set_intervallo_lettura() {
      this.$store.dispatch("cambia_intervallo_lettura_tank", {
        id_tank: this.tank.id,
        intervallo_lettura: this.intervallo_lettura,
      });
    },
    set_intervallo_ping_server() {
      this.$store.dispatch("cambia_intervallo_ping_server_tank", {
        id_tank: this.tank.id,
        intervallo_aggiornamento: this.intervallo_ping_server,
      });
    },
    delete_tank() {
      this.$store.dispatch("elimina_tank", this.tank.id);
    },
    read_request() {
      this.snackbar_richiesta = true;
      this.$store.dispatch("tank_read_request", this.tank.id);
    },
  },
};
